import React from 'react';

import WRow from './w_row';

const WBody = (props) => {
  const { header, first_row, bom_parameters, w_body } = props;

  return (
    <tbody>
      {w_body.map((row, index) => (
        <WRow
          key={`row_${index}`}
          row={row}
          row_index={index}
          header={header}
          first_row={first_row}
          bom_parameters={bom_parameters} />
      ))}
    </tbody>
  );
};

export default WBody;
